import { p as proxyCustomElement, H, h, c as Host } from './p-92c4a1ea.js';
import './p-a57042e3.js';
import { b as accessibility } from './p-756e7dc5.js';
import { u as useRef } from './p-e952b680.js';
import { a as ComponentUtils } from './p-de830ba7.js';
const progressSpinnerCss = "@-webkit-keyframes rotate{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes rotate{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-webkit-keyframes dash{0%{stroke-dasharray:1, 300;stroke-dashoffset:0}50%{stroke-dasharray:150, 300;stroke-dashoffset:-3.25rem}100%{stroke-dasharray:150, 300;stroke-dashoffset:-11.75rem}}@keyframes dash{0%{stroke-dasharray:1, 300;stroke-dashoffset:0}50%{stroke-dasharray:150, 300;stroke-dashoffset:-3.25rem}100%{stroke-dasharray:150, 300;stroke-dashoffset:-11.75rem}}.sc-owc-progress-spinner-h{stroke:var(--one-color-foreground-brand-base);stroke-width:calc(var(--one-spacing-size-7-xs) * 4);height:var(--one-spacing-size-m);width:var(--one-spacing-size-m)}.sc-owc-progress-spinner-h svg.sc-owc-progress-spinner{height:inherit;width:inherit}.owc-progress-spinner--mode-determinate.sc-owc-progress-spinner-h svg.sc-owc-progress-spinner{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.owc-progress-spinner--mode-determinate.sc-owc-progress-spinner-h svg.sc-owc-progress-spinner circle.sc-owc-progress-spinner{-webkit-transition:all 0.3s linear;transition:all 0.3s linear}.owc-progress-spinner--mode-indeterminate.sc-owc-progress-spinner-h svg.sc-owc-progress-spinner{-webkit-animation:rotate 2s linear infinite;animation:rotate 2s linear infinite;stroke:inherit;stroke-width:inherit}.owc-progress-spinner--mode-indeterminate.sc-owc-progress-spinner-h svg.sc-owc-progress-spinner circle.sc-owc-progress-spinner{stroke-dasharray:10, 200;stroke-dashoffset:0;-webkit-transition:stroke-dashoffset 0.5s linear;transition:stroke-dashoffset 0.5s linear;-webkit-animation:dash 2s ease-in-out infinite;animation:dash 2s ease-in-out infinite}.owc-progress-spinner--variant-secondary.sc-owc-progress-spinner-h{stroke:var(--one-color-foreground-base)}.owc-progress-spinner--variant-tertiary.sc-owc-progress-spinner-h{stroke:var(--one-color-foreground-intensity-lowest)}.owc-progress-spinner--size-xSmall.sc-owc-progress-spinner-h{stroke-width:calc(var(--one-spacing-size-7-xs) * 2);height:var(--one-spacing-size-xs);width:var(--one-spacing-size-xs)}.owc-progress-spinner--size-small.sc-owc-progress-spinner-h{stroke-width:calc(var(--one-spacing-size-7-xs) * 2);height:var(--one-spacing-size-s);width:var(--one-spacing-size-s)}.owc-progress-spinner--size-large.sc-owc-progress-spinner-h{height:var(--one-spacing-size-xl);width:var(--one-spacing-size-xl)}.owc-progress-spinner--size-xLarge.sc-owc-progress-spinner-h{height:var(--one-spacing-size-2-xl);width:var(--one-spacing-size-2-xl)}.owc-progress-spinner--size-xxLarge.sc-owc-progress-spinner-h{stroke-width:calc(var(--one-spacing-size-7-xs) * 5);height:var(--one-spacing-size-4-xl);width:var(--one-spacing-size-4-xl)}@media (forced-colors: active){.sc-owc-progress-spinner-h{stroke:buttontext}.owc-progress-spinner--variant-secondary.sc-owc-progress-spinner-h{stroke:buttontext}}";
const OwcProgressSpinnerStyle0 = progressSpinnerCss;
const DEFAULT_SIZE = 100;
const FULL = 100;
const HALF = 50;
const TWO = 2;
const THIRTY = 30;
const ProgressSpinner = /*@__PURE__*/proxyCustomElement(class ProgressSpinner extends H {
  constructor() {
    super();
    this.__registerHost();
    this.circleElement = useRef();
    this.component = new ComponentUtils(this);
    this.getAccessibilityAttributes = () => {
      if (this.mode === 'determinate') {
        return Object.assign({}, accessibility({
          role: 'progressbar',
          aria: {
            roledescription: 'progress spinner',
            valuemin: 0,
            valuemax: FULL,
            valuenow: this.value,
            valuetext: `${this.value} % `
          }
        }));
      }
      return Object.assign({}, accessibility({
        role: 'progressbar',
        aria: {
          roledescription: 'progress spinner'
        }
      }));
    };
    this.value = HALF;
    this.mode = 'indeterminate';
    this.variant = 'primary';
    this.size = 'medium';
  }
  handleProps() {
    var _a, _b;
    if (this.mode === 'determinate') {
      const radius = Math.max(0, Math.min(FULL, this.value));
      const circumference = Math.PI * TWO * THIRTY;
      const offset = (DEFAULT_SIZE - radius) / FULL * circumference;
      (_a = this.circleElement.current) === null || _a === void 0 ? void 0 : _a.style.setProperty('stroke-dasharray', `${circumference}`);
      (_b = this.circleElement.current) === null || _b === void 0 ? void 0 : _b.style.setProperty('stroke-dashoffset', `${offset}`);
    }
  }
  componentDidLoad() {
    this.handleProps();
  }
  render() {
    const hostClasses = this.component.getHostBemClasses({
      [`variant-${this.variant || 'primary'}`]: true,
      [`mode-${this.mode || 'indeterminate'}`]: true,
      [`size-${this.size || 'medium'}`]: true
    });
    return h(Host, Object.assign({
      key: '56f5fc474f85a5998f96355deeae4a037a3fdee3',
      class: hostClasses
    }, this.getAccessibilityAttributes()), h("svg", {
      key: 'd797d3cb28d490b69a329c51ba8e6eaf260eeedc',
      preserveAspectRatio: "xMidYMid meet",
      focusable: "false",
      viewBox: "0 0 70 70"
    }, h("circle", {
      key: '46b556e5ac9b3a9926a04dfa9b23115fe23ee593',
      ref: this.circleElement,
      cx: "50%",
      cy: "50%",
      r: "30",
      fill: "none"
    })));
  }
  get hostElement() {
    return this;
  }
  static get watchers() {
    return {
      "value": ["handleProps"],
      "mode": ["handleProps"]
    };
  }
  static get style() {
    return OwcProgressSpinnerStyle0;
  }
}, [2, "owc-progress-spinner", {
  "value": [514],
  "mode": [513],
  "variant": [513],
  "size": [513]
}, undefined, {
  "value": ["handleProps"],
  "mode": ["handleProps"]
}]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["owc-progress-spinner"];
  components.forEach(tagName => {
    switch (tagName) {
      case "owc-progress-spinner":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, ProgressSpinner);
        }
        break;
    }
  });
}
export { ProgressSpinner as P, defineCustomElement as d };